import {api,apitest} from '../api.request';

/**
 * 第一个
 * 
 */
function get1() {   
    return api.get("/get1")
}
/**
 * 第二个
 * 
 */
function get2() {   
  return api.get("/get2")
}

//年度线上销售额
const getAnnualOnlineSales=function(o){
  return apitest.get("/onlineOperation/annualOnlineSales",o)
}
//微商城&天猫近30天日销售趋势
const getMicroMallAndTmallSalesTrendInRecent30days=function(o){
  return apitest.get("/onlineOperation/microMallAndTmallSalesTrendInRecent30days",o)
}

// 微商城&天猫近50天日销售趋势
const getMicroMallAndTmallTop50Products=function(o){
  return apitest.get("/onlineOperation/microMallAndTmallTop50Products",o)
}

// 微商城访问次数----折线部分
const getNumberOfVisitsToMicroMallLine=function(o){
  return apitest.get("/onlineOperation/numberOfVisitsToMicroMallLine",o)
}

// 微商城访问次数----数字部分
const getNumberOfVisitsToMicroMallNumber=function(o){
  return apitest.get("/onlineOperation/numberOfVisitsToMicroMallNumber",o)
}

// 今日线上销售额
const getOnlineSalesToday=function(o){
  return apitest.get("/onlineOperation/onlineSalesToday",o)
}


// 微商城访问最多的TOP50商品
const getTop50CommoditiesVisitedMostInMicroMall=function(o){
  return apitest.get("/onlineOperation/top50CommoditiesVisitedMostInMicroMall",o)
}
export default {
  get1,
  get2,
  getAnnualOnlineSales,
  getMicroMallAndTmallSalesTrendInRecent30days,
  getMicroMallAndTmallTop50Products,
  getNumberOfVisitsToMicroMallLine,
  getNumberOfVisitsToMicroMallNumber,
  getOnlineSalesToday,
  getTop50CommoditiesVisitedMostInMicroMall
}